import { newsItems, newsSection, type NewsItem } from '../content';

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

/**
 * Format a `YYYY-MM-DD` string as "September 20, 2026".
 *
 * Deliberately not `Date`/`toLocaleDateString`: `new Date('2026-09-20')` parses
 * as UTC midnight and then renders in the viewer's zone, so anyone west of
 * Greenwich sees the previous day. A published date that shifts by a day is a
 * sourcing error on a page whose only asset is being right. Parsing the three
 * fields by hand keeps the output identical everywhere, tests included.
 * An unparseable string falls back to itself rather than throwing.
 */
export function formatNewsDate(iso: string): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  if (!match) return iso;
  const month = MONTHS[Number(match[2]) - 1];
  if (!month) return iso;
  return `${month} ${Number(match[3])}, ${match[1]}`;
}

function NewsEntry({ item }: { item: NewsItem }) {
  return (
    <li className="news__item">
      <p className="news__meta">
        <span className="news__outlet">{item.outlet}</span>
        <span className="news__date">{formatNewsDate(item.date)}</span>
      </p>

      <h3 className="news__headline">
        <a href={item.url} target="_blank" rel="noreferrer noopener">
          {item.headline}
        </a>
      </h3>

      <p className="news__summary">{item.summary}</p>
    </li>
  );
}

export function News() {
  return (
    <section className="section" id="news" aria-labelledby="news-heading">
      <div className="section__inner section__inner--narrow">
        <h2 id="news-heading" className="section__title">
          {newsSection.heading}
        </h2>
        <p className="section__lede">{newsSection.lede}</p>

        <ul className="news__list">
          {newsItems.map((item) => (
            <NewsEntry key={item.url} item={item} />
          ))}
        </ul>
      </div>
    </section>
  );
}
